import * as fs from "node:fs/promises";
import pLimit from './../../_node_modules/p-limit/index.js';
const SM_FS_LIMIT = Number.isNaN(Number(process.env.SM_FS_LIMIT)) ? void 0 : Number(process.env.SM_FS_LIMIT);
const CONCURRENT_FILE_DESCRIPTORS_LIMIT = SM_FS_LIMIT ?? 1024;
const fsLimit = pLimit(CONCURRENT_FILE_DESCRIPTORS_LIMIT);
const wrapWithFSLimit = (fn) => {
  return (...args) => fsLimit(() => fn(...args));
};
const access = wrapWithFSLimit(fs.access);
const mkdir = wrapWithFSLimit(fs.mkdir);
const readFile = wrapWithFSLimit(fs.readFile);
const readdir = wrapWithFSLimit(fs.readdir);
const rm = wrapWithFSLimit(fs.rm);
const writeFile = wrapWithFSLimit(fs.writeFile);
export {
  access,
  mkdir,
  readFile,
  readdir,
  rm,
  writeFile
};
//# sourceMappingURL=fsLimit.js.map
